import { useSelector } from 'react-redux';
export const useUser = () => {
  return useSelector(state => state.auth.user);
};
export const useUserScopes = () => {
  const user = useUser();
  return user.scopes;
};